import React, { useMemo } from 'react';

import { AccountingCode, Course } from 'app2/api';
import { Dropdown, DropdownProps, FieldInfo } from 'app2/components';
import { useSiteAccountingCodesQuery, SiteAccountingCodesSelections, siteAccountingCodes } from 'app2/views/shared/sites/generated';
import { findQueryOption } from 'app2/views/shared-public';

interface CourseAccountingCodePicker {
  field?:FieldInfo<Course>;
  site?:string;
}

type Props = Omit<DropdownProps, 'options'> & CourseAccountingCodePicker;

export function CourseAccountingCodePicker(props: Props) {
  const { site, ...remaining } = props;
  const options = getOptions();

  function render() {
    return <Dropdown options={options} clearable {...remaining} />
  }

  function getOptions(): any[] {
    const [result] = useSiteAccountingCodesQuery({variables: { site }, hideLoader: true})
    return useMemo(() => result.data?.site?.accountingCodes?.map((item) => ({ value: item, label: item.label })) || [], [result]);
  }

  return render();
}

export async function findSiteAccountingCode(nameOrObArray:number | string | Pick<AccountingCode, 'id' | 'label'> | string[] | Pick<AccountingCode, 'id' | 'label'>[], props:CourseAccountingCodePicker):Promise<SiteAccountingCodesSelections['accountingCodes'][0]> {
  const { site } = props;

  if (!site) {
    return;
  }

  return findQueryOption(siteAccountingCodes, {site}, nameOrObArray, 'label')
}

CourseAccountingCodePicker.findSiteAccountingCode = findSiteAccountingCode;
